import { useSelector } from "react-redux";
import { RootState } from "../index";


export const getFeedBackFields = () => useSelector((state: RootState) => state?.feedback);
